import React, { Component } from 'react'
import DashboardCleanersAdminHeader from '../../Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import '../../../CSS/dashboard.css'
import * as DashboardError401Constant from './ErrorsAdminConstant'
import {destroySession} from '../../../Utility/Utility'
import { Redirect } from 'react-router-dom'


class CleanersAdminDashboardError401 extends Component {
	constructor(props) {
        super(props);
        this.state= {
            count: false,
            redirectLogin: false,
            time: DashboardError401Constant.Error401LoginTime
        }
	}
    timer() {
        this.setState({
          time: this.state.time - 1
        })
        if (this.state.time < 1) {
          clearInterval(this.interValid);
          this.setState({ count: true })
        }
      }
      componentDidMount() {
        this.interValid = setInterval(this.timer.bind(this), 1000);
        destroySession();
      }
      componentWillMount(){
        clearInterval(this.interValid);
      }
    
	render() {
        if (this.state.count) {
            return (<Redirect to={'/CleanersDashboardTokenExpire'} />)
        }
		return (
			<div>
				<DashboardCleanersAdminHeader/>
                    <div className="ErrorDashboard">
                    <p>{DashboardError401Constant.Error401DashboardParagraph}</p>
                    <p>Redirecting to the login page in {this.state.time} seconds</p>
				</div>
			</div>
		)
	}
}

export default CleanersAdminDashboardError401;